import { ChevronRight } from '@ixigo/icons';
import Accordion from '@ixigo/iui/Accordion';
import AccordionBody from '@ixigo/iui/AccordionBody';
import AccordionHead from '@ixigo/iui/AccordionHead';
import Typography from '@ixigo/iui/Typography';
import clsx from 'clsx';
import { FC, useCallback, useEffect, useState } from 'react';
import { getAboutContent } from '../../apis/service';
import { isMobile } from '../../utils/common';
import { AboutContent } from './index.types';

const About: FC = () => {
    const [data, setData] = useState<AboutContent>();
    const [readMore, setReadMore] = useState(false);
    const isMob = isMobile();

    const fetchContent = useCallback(async () => {
        try {
            const response = await getAboutContent();
            setData(response);
        } catch (e) {
            // NoOp
        }
    }, []);

    useEffect(() => {
        fetchContent();
    }, [fetchContent]);

    if (!data) return null;

    const { disclaimer, headings, questions } = data;

    if (isMob)
        return (
            <div className='p-20 pt-10 text-center'>
                <Typography
                    variant='body-sm'
                    className={clsx('text-charcoal-600', !readMore && 'line-clamp-3')}
                    dangerouslySetInnerHTML={{ __html: disclaimer }}
                />
                <button type='button' onClick={() => setReadMore((prev) => !prev)}>
                    <Typography variant='body-sm' className='text-charcoal-600 underline'>
                        {readMore ? 'read less' : 'read more'}
                    </Typography>
                </button>
            </div>
        );

    return (
        <div className='col-span-2 py-30'>
            <Typography fontWeight='medium' variant='h4' className='mb-10'>
                {headings.pageHeading}
            </Typography>
            <Typography variant='body-md' className='mb-20'>
                {headings.pageSubHeading}
            </Typography>
            <div className='flex flex-col gap-10 px-30 py-20 border border-charcoal-100 rounded-20'>
                {questions.map((question) => (
                    <Accordion key={question._id}>
                        <AccordionHead className='py-10' expandIcon={<ChevronRight className='rotate-90' />}>
                            <Typography variant='body-lg'>{question.header.en}</Typography>
                        </AccordionHead>
                        <AccordionBody>
                            <Typography
                                variant='body-md'
                                className='text-charcoal-600 [&_ol]:pl-20 [&_ol]:pt-10 [&_ol]:list-disc [&_ul]:pt-10 [&_ul]:pl-20 [&_ul]:list-decimal'
                                dangerouslySetInnerHTML={{ __html: question.content.en }}
                            />
                        </AccordionBody>
                    </Accordion>
                ))}
            </div>
            <Typography
                variant='body-sm'
                className='mt-40 text-charcoal-600'
                dangerouslySetInnerHTML={{ __html: disclaimer }}
            />
        </div>
    );
};

export default About;
